import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {initSubgrid, reinitializeSubgrid, unmountSubgrid} from "@mnjsplatform/data/lib/actions/subgridActions";
import SubgridPlaceholder from "../Subgrid/SubgridPlaceholder";
import UrProvider from "@mnjsplatform/data/lib/api/UrProvider";

class MultiSelectWrapper2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subgridKey: null
    };
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {

    if(this.state.subgridKey && this.props.parentDataItem.isParamItem)
    {
      if(!this.execParamsPrev) {
        const urProcessed = this.props.parentDataItem.rawData.ColumnUpdateRules[this.props.fieldInfo.Name];
        const urProvider = new UrProvider(urProcessed);
        const execParams = urProvider.getParamsForExecRules(this.props.parentDataItem, this.props.rowIndex);

        this.execParamsPrev = Object.fromEntries(Object.entries(execParams).filter(
            ([key, val])=> {
              const isHidden = this.props.parentDataItem.getFieldIsHidden(key, 0);
              const fi = this.props.parentDataItem.getFieldInfo(key);
              const title = this.props.parentDataItem.getTitle(fi, 0);
              const hasTitle = !title ? false : title.length > 0;
              const isSelf = key === this.props.fieldInfo.Name;

              return !isHidden && !isSelf && hasTitle && key !== "SSetTableName" && key !== "SSetObjectKeyName";
            }
        ));
      }

      let needRefresh = false;
      //let newPars = {}

      Object.keys(this.execParamsPrev).forEach((key) => {


          if(this.execParamsPrev[key] !== this.props.parentDataItem.getField(0, key))
            needRefresh = true;

        this.execParamsPrev[key] = this.props.parentDataItem.getField(0, key);
      });

      //this.execParamsPrev = newPars;

      if (needRefresh) {
        await this.fillSubgrid(false, true, this.execParamsPrev);

        if(this.props.updateLabel)
          await this.props.updateLabel();
      }
    }


  }

  async componentWillUnmount() {
    await this.unmount();
  }

  initSubgrid = async() => {
    await this.props.initComponent();
    if (!this.state.subgridKey) {
      const key = await this.props.dispatch(initSubgrid(
        this.props.parentDataItem,
        this.props.fieldInfo.Name,
        this.props.rowIndex,
        this.props.rootPath,
        this.props.readOnly,
        this.props.withSubgridParams
      ));
      this.setState({ subgridKey: key });
    }
  };

  fillSubgrid = async(toSelect, execParamsChanged = false, execParams = {}) => {
    const parameters = {
      ToFillSSet: toSelect ? 1 : 0,
      ExecParamsChanged: execParamsChanged ? 1 : 0,
      ...execParams
    };

    await this.props.dispatch(reinitializeSubgrid(this.props.parentDataItem, this.state.subgridKey, parameters));
  };

  unmount = async() => {
    if (this.props.unmountComponent) {
      await this.props.unmountComponent();
    }
    if (this.state.subgridKey) {
      await this.props.dispatch(unmountSubgrid(this.props.parentDataItem, this.state.subgridKey));
    }
  };

  render() {
    return (
      <SubgridPlaceholder subgridKey={this.state.subgridKey}
                          alwaysRenderChildren={true}
      >
        {(subgridItem, subgridItemParams) => this.props.children({
          ...this.props,
          subgridItem,
          subgridItemParams,
          init: this.initSubgrid,
          fill: this.fillSubgrid
        })}
      </SubgridPlaceholder>
    );
  }
}

MultiSelectWrapper2.propTypes = {
  initComponent: PropTypes.func.isRequired,
  unmountComponent: PropTypes.func,
  dispatch: PropTypes.func,
  parentDataItem: PropTypes.object.isRequired,
  fieldInfo: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rootPath: PropTypes.string,
  readOnly: PropTypes.bool,
  withSubgridParams: PropTypes.bool,
  updateLabel: PropTypes.func
};

MultiSelectWrapper2.defaultProps = {
  withSubgridParams: false
};

export default connect()(MultiSelectWrapper2);